export default class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return "".concat(this.reason, ": ").concat(this.explanation);
    } else {
      return this.reason;
    }
  }
}